import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Check } from "lucide-react";
import { useTranslations } from "modules/i18n/hooks/useTranslations";

/**
 * Success message shown after successful subscription.
 * Includes confirmation and help text with popover for troubleshooting.
 */
export const SuccessMessage = () => {
  "use memo";

  const $ = _c(24);
  const [showPopover, setShowPopover] = useState(false);
  const t = useTranslations("newsletters");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex size-10 items-center justify-center rounded-full bg-green-300 text-black"><Check className="size-6" strokeWidth={1.5} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("v2.success.heading");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex flex-col items-center justify-center gap-4">{t0}<h3 className="text-xl font-semibold md:text-2xl">{t1}</h3></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("v2.success.message");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== showPopover) {
    t4 = () => setShowPopover(!showPopover);
    $[7] = showPopover;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("v2.success.help_link");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <button onClick={t4} className="cursor-pointer text-gray-600 underline hover:text-indigo-500 hover:no-underline">{t5}</button>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== showPopover || $[15] !== t) {
    t7 = showPopover && <span className="mt-2 block text-sm text-gray-600">{t("v2.success.help_text")}</span>;
    $[14] = showPopover;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t3 || $[18] !== t6 || $[19] !== t7) {
    t8 = <p className="mb-4 text-base">{t3}{" "}{t6}{t7}</p>;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t2 || $[22] !== t8) {
    t9 = <div className="flex min-h-20 flex-col items-center justify-center gap-1 text-center"><div className="flex flex-col items-center justify-center gap-2">{t2}{t8}</div></div>;
    $[21] = t2;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};